import { getCurrentEnvironment } from '@general/env';

export const transformDataToAlgoliaAnalytics = data => {
    const { type } = data;
    const { hit, index } = data?.unfiltered?.click;
    const env = getCurrentEnvironment();

    let readyData = {
        index,
        eventName: data?.click?.value,
        queryID: hit?.__queryID,
        objectIDs: [hit?.objectID],
    };

    // console.log('Data before Algolia Transform', data);

    switch (type) {
        case 'click':
            readyData = { ...readyData, positions: [hit?.__position] };
            break;
        case 'conversion':
            readyData = { ...readyData };
            break;

        default:
            if (env !== 'production') {
                console.error('No type for tracking provided. Data not sent to Algolia analytics.');
                console.log('trackingData at error:', data);
            }
            break;
    }

    return readyData;
};
